// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5PqTB","controls":"styles_controls__EdWkH","charLimit":"styles_charLimit__3e0Hd","input":"styles_input__1hcbi","send":"styles_send__2ktLa"};